import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO
 */
export const cacheList = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    plugin.feature.actions.list.success
      .observe()
      .pipe(
        rxjs.map(action =>
          plugin.collection.plugins.cachePlugin.feature.actions.put
            .from(action)
            .create(action.data.response),
        ),
      ),
)
